export default __webpack_public_path__ + "static/media/pit-crew-background.7f1dbb9d.webp";